<template>
    <div class="modal fade" tabindex="-1" role="dialog" aria-hidden="true" id="confirmation-modal" data-backdrop="static" data-keyboard="false">
        <div class="modal-dialog">
            <div class="modal-content">
                <!--<div class="modal-header">-->
                    <!--<h4 class="modal-title">{{ lang.app.global.add_invoice_lines }}</h4>-->
                <!--</div>-->
                <div class="modal-body" v-html="message">
                </div>

                <div class="modal-footer">
                    <button type="button" class="btn color-black btn-outline-primary" @click="result(false)">{{ lang.common.cancel }}</button>
                    <button type="button" :class="'btn color-white ' + (product ? 'background-' + product : 'btn-danger')" @click="result(true)">{{ lang.common.confirm }}</button>
                </div>

            </div>
        </div>
    </div>
</template>
<style scoped>
    .btn-outline-primary {
        border: 1px solid;
        background-color: transparent;
    }
    .btn-outline-primary:hover {
        color: white !important;
        background-color: #333333;
    }
</style>
<script>
    export default {
        props: ['message', 'isOpen', 'product'],
        methods: {
            result: function(val) {
                this.$emit('result', val);
            }
        },
        watch: {
            'isOpen' : function(val){
                if (val) {
                    $("#confirmation-modal").modal('show');
                } else {
                    $("#confirmation-modal").modal('hide');
                }
            }
        }

    }
</script>



// WEBPACK FOOTER //
// resources/js/components/common/ConfirmationModal.vue